module.exports = __webpack_public_path__ + "img/manual-grn-02-scan-qr.31e9044f.png";